import {
  Component,
  input,
  booleanAttribute,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-spinner',
  template: `
    @if (loading()) {
      <p-progress-spinner ariaLabel="loading" />
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ProgressSpinnerModule],
})
export class SpinnerComponent {
  loading = input.required({ transform: booleanAttribute });
}
